// extracted by mini-css-extract-plugin
export default {"tagContainer":"WRk2NeWErJq5hnmD5cAX__tagContainer___","aliasContainer":"cxzot5PT6COjyS8LCwE7__aliasContainer___"};